'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import InstantLoaderInner from './InstantLoaderInner';

export default function InstantLoaderContent({ color }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return (
    <InstantLoaderInner
      pathname={pathname}
      searchParams={searchParams}
      color={color}
    />
  );
}
